export default "__VITE_ASSET__BYOxofIu__"